// import "./AdminUtilities/axiosMock";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider, useConfig } from "./common/context/ConfigContext";
import logger from "./common/services/logServise";

import "./index.css";
import AnamgisApp from "./Anamgis/App";
import MapiApp from "./Mapi/App";
import AdminUtilitiesApp from "./AdminUtilities/App";
import store from "./store";
import { Provider } from "react-redux";
import { setConfig } from "./common/redux/slices/configSlice";
import { useSelector } from "react-redux";
import { selectIsMapi, selectConfig } from "./common/redux/slices/configSlice";

logger.init();

const App = () => {
  //before redux refactor
  /*const config = useConfig();
  if (!config) return <div>Loading configuration...</div>; // Wait for config to load

  // Choose app based on the active project in the config
  const isMapi = config.project === "Mapi";
  */

  const config = useSelector(selectConfig);
  if (Object.keys(config).length === 0)
    return <div>Loading configuration...</div>; // Wait for config to load
  const project = config.project;

  if (project === "Mapi") {
    return (
      <MapiApp
        reportsEndPoint={config.reportsEndPoint}
        generalEndPoint={config.generalEndPoint}
        usersEndPoint={config.usersEndPoint}
        searchEndPoint={config.searchEndPoint}
        socketConnectionEndPoint={config.socketConnectionEndPoint}
      />
    );
  }

  if (project === "Anamgis") {
    return (
      <AnamgisApp
        reportsEndPoint={config.reportsEndPoint}
        generalEndPoint={config.generalEndPoint}
        usersEndPoint={config.usersEndPoint}
        searchEndPoint={config.searchEndPoint}
        socketConnectionEndPoint={config.socketConnectionEndPoint}
      />
    );
  }

  // default fallback to AdminUtilitiesApp
  return (
    <AdminUtilitiesApp
      apiEndPoint={config.apiEndPoint}
      applicationName={config.applicationName}
    />
  );
};

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConfigProvider>
  </Provider>,
  document.getElementById("root")
);
